// Images
import * as Icons from "./assets/icons";

export const iconLib = {
  登出: Icons.Logout,
  請登入: Icons.Login,

  賬戶管理: Icons.Account,
  我的賬戶: Icons.Account,

  訂單管理: Icons.Orders,
  訂單查詢: Icons.Orders,

  我的最愛: Icons.Favorites,

  直銷商專區: Icons.ABO,
  特惠活動: Icons.Promos,
  認購專區: Icons.Purchase,
  安麗台灣40週年活動: Icons.Event,
  安麗台灣40週年集章活動: Icons.Event,

  購物常見問題: Icons.Help,
};

export const target = {
  登出: "/logout",
  請登入: "/login",

  個人資料: "/profile",
  地址薄: "/address",
  續約: "/profile/renew",

  我的最愛: "/favorites",

  一般訂單查詢: "/orders/orders",
  退換貨: "/orders/returns",
  長客計畫查詢: "/orders/soporders",
  售後維修: "/orders/repair",

  打包清單: "/mylist",
  快速訂貨: "/bulkorders",
  認購專區: "/privilegeorders",
  特惠活動: "/promotions",
  安麗台灣40週年集章活動: "/a40stamps",
  購物常見問題: "/shoppingfaq",

  維修後: "/afterservice",
};

export const constructMenu = (menuList) => {
  // convert list from contentstack to organized list
  let sorted = menuList.sort((a, b) => parseInt(b.sort) - parseInt(a.sort)); // sort descending
  let organized = {};
  let finalMenu = [];
  let parentList = {};
  sorted.map((m) => {
    // TODO: Remove later, use while contentstack not ready -->
    //if (!m.target_url.link.href)
    //    m.target_url.link.href = target[m.title];
    // Add temp images, while contentStack not provide yet
    if (m.parent_menu.length === 0 && (m.icon === null || (m.icon && m.icon.url === null))) {
      // parent only

      m.icon = { url: iconLib[m.title] ? iconLib[m.title].default : null };
    }
    // end <--

    if (m.parent_menu.length === 0) {
      // parent
      parentList[m.uid] = false;
      if (organized[m.uid]) {
        // exists
        organized[m.uid].menu = m;
      } else {
        // new
        organized[m.uid] = { menu: m, children: [] };
      }
    } else {
      if (m.parent_menu[0].uid) {
        if (organized[m.parent_menu[0].uid]) {
          // exists
          organized[m.parent_menu[0].uid].children.push(m);
        } else {
          // new
          organized[m.parent_menu[0].uid] = { menu: {}, children: [m] };
        }
      }
    }
  });

  Object.keys(organized).map((uid) => {
    finalMenu.push(organized[uid]);
  });

  return [finalMenu, parentList];
};

export const findParentUID = (menuList, currentPath) => {
  let parentId = "";
  if (menuList && menuList.length > 0 && currentPath !== "") {
    menuList.map((m) => {
      m.children.map((c) => {
        if (c.target_url.link.href === currentPath) {
          parentId = m.menu.uid;
        }
      });
    });
  }
  return parentId;
};
